import {
  IWorkoutFullInviteDTO,
  IWorkoutInviteBaseDTO,
  IWorkoutShortInviteDTO,
} from '../@types/DTO/workoutsInvites.dto.types';
import {
  IWorkoutBaseInvite,
  IWorkoutFullInvite,
  IWorkoutShortInvite,
} from '../@types/workoutsInvites.types';

export const mapWorkoutBaseInviteToFront = (
  backData: IWorkoutInviteBaseDTO,
): IWorkoutBaseInvite => {
  return {
    id: +backData.id,
    created_at: new Date(backData.created_at),
    accepted_at: backData.accepted_at ? new Date(backData.accepted_at) : null,
    rejected_at: backData.rejected_at ? new Date(backData.rejected_at) : null,
    author: {
      id: +backData.author_id,
      name: backData.author_name,
      surname: backData.author_surname,
      photo: backData.author_photo,
    },
  };
};

export const mapWorkoutFullInviteToFront = (
  backData: IWorkoutFullInviteDTO,
): IWorkoutFullInvite => {
  return {
    ...mapWorkoutBaseInviteToFront(backData),
    workout: {
      id: +backData.id_workout,
      name: backData.name,
      description: backData.description,
      type: {
        id: +backData.workout_type_id,
        name: backData.workout_type_name,
      },
    },
    track: {
      id: +backData.id_workout_track,
      start: new Date(backData.date_start),
      finish: new Date(backData.date_finish),
      distance: +backData.distance,
    },

    group: !backData.workout_group_id
      ? null
      : {
          id: +backData.workout_group_id,
          name: backData.workout_group_name!,
        },
  };
};

export const mapWorkoutShortInviteToFront = (
  backData: IWorkoutShortInviteDTO,
): IWorkoutShortInvite => {
  return {
    ...mapWorkoutBaseInviteToFront(backData),
    user: {
      id: +backData.user_id,
      name: backData.user_name,
      surname: backData.user_surname,
      photo: backData.user_photo,
    },
  };
};
